import { render } from "./RegistrationApprove.vue?vue&type=template&id=1013b124&scoped=true"
import script from "./RegistrationApprove.vue?vue&type=script&lang=js"
export * from "./RegistrationApprove.vue?vue&type=script&lang=js"

import "./RegistrationApprove.vue?vue&type=style&index=0&id=1013b124&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1013b124"]])

export default __exports__